export const eventListRoutes = {
  path: '',
  name: 'EventList',
  component: () => import('@/views/event/index.vue'),
  meta: {
    hidden: false,
    title: 'Event List'
  }
}



